import React, { createContext, useState, useContext } from 'react';

// 1. Create the context
const HoverContext = createContext();

// 2. Create a "Provider" component. This component will hold the state
// and provide it to all its children.
export const HoverProvider = ({ children }) => {
  const [hoveredUrl, setHoveredUrl] = useState('');

  const value = { hoveredUrl, setHoveredUrl };

  return (
    <HoverContext.Provider value={value}>
      {children}
    </HoverContext.Provider>
  );
};

// 3. Create a custom hook to make it easy to use the context
export const useHover = () => {
  return useContext(HoverContext);
};